'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var resolveAsyncProperties = exports.resolveAsyncProperties = function resolveAsyncProperties() {
  var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onError = arguments[1];
  var callback = arguments[2];

  var resolved = {};
  var propertyKeys = Object.keys(properties);
  var propertiesLength = propertyKeys.length;
  var deferred = propertyKeys.reduce(function (accumulator, key) {
    var value = properties[key];
    if (value && typeof value === 'function') {
      value = value();
      if (value && typeof value.then === 'function') {
        accumulator.push({ key: key, promise: value });
      } else {
        resolved[key] = value;
      }
    } else {
      resolved[key] = value;
    }
    return accumulator;
  }, []);
  var check = function check() {
    if (Object.keys(resolved).length === propertiesLength) {
      callback(resolved);
    }
  };

  if (deferred.length) {
    deferred.forEach(function (_ref) {
      var key = _ref.key,
          promise = _ref.promise;

      promise.then(function (value) {
        resolved[key] = value;
        check();
      }).catch(function (err) {
        resolved[key] = undefined;
        onError(err);
        check();
      });
    });
  } else {
    callback(resolved);
  }
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.74/js/common/promises.js
// module id = 403
// module chunks = 0